/**
 * Subscription Widget Integration
 * Handles all subscription widget functionality including selling plans integration
 */

// Function to parse selling plan names to a simpler format
function parseSellingPlanName(planName) {
  if (!planName) return '';

  if (planName.includes('Monate')) {
    const parts = planName.split('Monate');
    const firstParts = parts[0].trim().split(' ');
    return `${firstParts[firstParts.length - 1]} Monate`;
  } else if (planName.includes('Monat')) {
    const parts = planName.split('Monat');
    const firstParts = parts[0].trim().split(' ');
    return `${firstParts[firstParts.length - 1]} Monat`;
  }

  return planName;
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function () {
  // Simple direct approach to handle subscription widget functionality

  // Variable to store the last selected subscription plan ID
  let lastSelectedSubscriptionPlanId = '';

  const isBuyboxControl = (el) => Boolean(el?.closest?.('[data-e1-pdp-buybox]') || el?.hasAttribute?.('data-e1-pdp-option'));

  initSubscriptionWidget();

  function initSubscriptionWidget() {
    // Get all radio buttons — never the SHOP-35 Mario buybox tiles.
    const allRadios = [...document.querySelectorAll('input[type="radio"][name^="purchaseOption_"]')].filter((radio) => !isBuyboxControl(radio));
    const oneTimeRadios = [...document.querySelectorAll('input[data-radio-type="one_time_purchase"]')].filter((radio) => !isBuyboxControl(radio));
    const subscriptionRadios = [...document.querySelectorAll('input[data-radio-type="subscription"]')].filter((radio) => !isBuyboxControl(radio));

    //console.log("Found radios - All:", allRadios.length, "One-time:", oneTimeRadios.length, "Subscription:", subscriptionRadios.length);

    // Ensure all add-to-cart forms have a selling_plan input
    const cartForms = document.querySelectorAll('form[action*="/cart/add"]');
    cartForms.forEach(form => {
      // Find or create the selling_plan input in the form
      let formSellingPlanInput = form.querySelector('input[name="selling_plan"]');
      if (!formSellingPlanInput) {
        formSellingPlanInput = document.createElement('input');
        formSellingPlanInput.type = 'hidden';
        formSellingPlanInput.name = 'selling_plan';
        form.appendChild(formSellingPlanInput);
        //console.log("Added selling_plan input to form:", form.id || 'unnamed form');
      }
    });

    // Add click handlers to all radio buttons
    allRadios.forEach(radio => {
      // Handle change event
      radio.addEventListener('change', function () {
        if (this.checked) {
          //console.log("Radio changed:", this.dataset.radioType);

          // Direct update for all radio types
          updateSelection(this);
        }
      });

      // Make the parent item clickable
      const parentItem = radio.closest('.subscription-widget__item');
      if (parentItem) {
        parentItem.addEventListener('click', function (e) {
          // Don't trigger if clicking on a dropdown or its options or the radio itself
          if (e.target.closest('.subscription-plan-dropdown') ||
            e.target.closest('.subscription-plan-options') ||
            e.target.closest('.subscription-plan-option') ||
            e.target === radio) {
            return;
          }

          //console.log("Parent item clicked for:", radio.dataset.radioType);
          radio.checked = true;

          // Direct update for all radio types
          updateSelection(radio);
        });
      }
    });

    // Setup dropdown functionality
    setupDropdowns();

    // Setup one-time quantity tiles functionality
    setupOnetimeQuantityTiles();

    // Setup commitment boxes functionality (now handled by regular radio button logic)

    // Initialize quantity tiles visibility based on current selection
    initializeQuantityTilesVisibility();

    // Setup commitment tiles if they exist
    setupCommitmentTiles();

    // Trial card CTA triggers the theme add-to-cart button
    setupTrialCardCta();

    // Initialize One-Time Box animation
    initializeOnetimeBoxAnimation();

    // Initialize with subscription selected by default
    if (subscriptionRadios.length > 0) {
      // Get all subscription options
      const allOptions = document.querySelectorAll('.subscription-plan-option');

      // Find the monthly option (usually contains "Monat" in the name)
      let monthlyOption = null;
      allOptions.forEach(option => {
        if (option.dataset.sellingPlanName && option.dataset.sellingPlanName.includes('Monat')) {
          monthlyOption = option;
        }
      });

      // If we found a monthly option, use it as the default
      if (monthlyOption) {
        lastSelectedSubscriptionPlanId = monthlyOption.dataset.sellingPlanId;
        //console.log("Initialized last selected subscription plan ID (monthly):", lastSelectedSubscriptionPlanId);
      } else {
        // Otherwise use the first option
        const initialOption = document.querySelector('.subscription-plan-option');
        if (initialOption && initialOption.dataset.sellingPlanId) {
          lastSelectedSubscriptionPlanId = initialOption.dataset.sellingPlanId;
          //console.log("Initialized last selected subscription plan ID (first option):", lastSelectedSubscriptionPlanId);
        }
      }

      // Set the subscription radio as checked
      subscriptionRadios[0].checked = true;
      updateSelection(subscriptionRadios[0]);

      // Apply the selected plan
      setTimeout(() => {
        restoreLastSelectedSubscriptionPlan();
      }, 100);
    }
  }

  // Setup trial card CTA — delegates to the product add-to-cart button
  function setupTrialCardCta() {
    // Rotate the accordion chevron on open/close (inline styles can't target details[open])
    const trialAccordions = document.querySelectorAll('.trial-accordion');
    trialAccordions.forEach(function (details) {
      const chevron = details.querySelector('.trial-accordion__chevron');
      if (!chevron) return;
      details.addEventListener('toggle', function () {
        chevron.style.transform = details.open ? 'rotate(180deg)' : 'rotate(0deg)';
      });
    });

    const trialCtaButtons = document.querySelectorAll('[data-trial-cta]');

    // When the Probieraktion card is present, its own "Jetzt probieren" button
    // replaces the standalone add-to-cart button below the widget. Hide that
    // button's block (it stays in the DOM so the card CTA can still click it).
    if (trialCtaButtons.length > 0) {
      const standaloneAddToCart = document.querySelector('add-to-cart-component button[name="add"]');
      if (standaloneAddToCart) {
        const hideTarget =
          standaloneAddToCart.closest('.buy-buttons-block') ||
          standaloneAddToCart.closest('.product-form-buttons') ||
          standaloneAddToCart.closest('add-to-cart-component');
        if (hideTarget) {
          hideTarget.style.display = 'none';
        }
      }
    }

    trialCtaButtons.forEach(function (ctaButton) {
      ctaButton.addEventListener('click', function (e) {
        e.preventDefault();

        const trialCard = ctaButton.closest('.subscription-widget__item');
        const trialRadio = trialCard
          ? trialCard.querySelector('input[data-radio-type="subscription"]')
          : null;

        if (trialRadio) {
          trialRadio.checked = true;
          updateSelection(trialRadio);
        }

        const addToCartButton = document.querySelector('add-to-cart-component button[name="add"]');
        if (addToCartButton && !addToCartButton.disabled) {
          addToCartButton.click();
        }
      });
    });
  }

  // Function to update UI based on selection
  function updateSelection(selectedRadio) {
    if (!selectedRadio || isBuyboxControl(selectedRadio)) return;

    //console.log("Updating selection for:", selectedRadio.dataset.radioType);

    // Update all items first (deselect everything)
    const allItems = document.querySelectorAll('.subscription-widget__item');
    allItems.forEach(item => {
      // Remove selected class
      item.classList.remove('selected');

      // Remove background and price color classes
      if (item.dataset.bgSelected) {
        item.classList.remove(item.dataset.bgSelected);
      }

      // Remove price color classes
      const prices = item.querySelectorAll('.subscription-widget__item-price');
      if (prices && prices.length > 0 && item.dataset.priceSelected) {
        prices.forEach(price => price.classList.remove(item.dataset.priceSelected));
      }

      // Update radio visual state
      const itemRadioSelected = item.querySelector('.radio-selected');
      const itemRadioDeselected = item.querySelector('.radio-deselected');
      if (itemRadioSelected && itemRadioDeselected) {
        itemRadioSelected.classList.add('hidden');
        itemRadioDeselected.classList.remove('hidden');
      }
    });

    // Update selected item
    const selectedItem = selectedRadio.closest('.subscription-widget__item');
    if (selectedItem) {
      // Add selected class
      selectedItem.classList.add('selected');

      // Add background class
      if (selectedItem.dataset.bgSelected) {
        selectedItem.classList.add(selectedItem.dataset.bgSelected);
      }

      // Add price color classes
      const selectedPrices = selectedItem.querySelectorAll('.subscription-widget__item-price');
      if (selectedPrices && selectedPrices.length > 0 && selectedItem.dataset.priceSelected) {
        selectedPrices.forEach(price => price.classList.add(selectedItem.dataset.priceSelected));
      }

      // Update radio visual state
      const selectedRadioSelected = selectedItem.querySelector('.radio-selected');
      const selectedRadioDeselected = selectedItem.querySelector('.radio-deselected');
      if (selectedRadioSelected && selectedRadioDeselected) {
        selectedRadioSelected.classList.remove('hidden');
        selectedRadioDeselected.classList.add('hidden');
      }
    }

    // Update selling plan ID in all forms
    updateSellingPlanInForms(selectedRadio);

    // Update quantity in forms if it's a one-time purchase
    if (selectedRadio.dataset.radioType === 'one_time_purchase') {
      // If switching to one-time purchase, ensure first tile is selected if none is selected
      ensureOnetimeTileSelected();
      if (selectedRadio.dataset.quantity) {
        updateQuantityInForms(selectedRadio.dataset.quantity);
      }
    } else if (selectedRadio.dataset.radioType === 'subscription') {
      // If subscription is selected, deselect all one-time quantity tiles and reset quantity to 1
      deselectAllOnetimeTiles();
      updateQuantityInForms('1');
    }

    // If one-time purchase is selected, show quantity tiles
    if (selectedRadio.dataset.radioType === 'one_time_purchase') {
      showOnetimeQuantityTiles();
    } else if (selectedRadio.dataset.radioType === 'subscription') {
      // If subscription is selected, hide quantity tiles
      hideOnetimeQuantityTiles();
    }

    // Update border colors for selected option
    updateBorderColors(selectedRadio);

    // Update sticky cart prices
    updateStickyCartValues(selectedRadio);
  }



  // Function to update selling plan ID in all forms
  function updateSellingPlanInForms(selectedRadio) {
    let sellingPlanId = '';

    // Determine the selling plan ID based on the selected radio
    if (selectedRadio.dataset.radioType === 'one_time_purchase') {
      // For one-time purchase, selling plan ID should be empty
      sellingPlanId = '';
      //console.log("One-time purchase selected, selling plan ID cleared");
    } else if (selectedRadio.dataset.radioType === 'subscription' || selectedRadio.dataset.radioType === 'selling_plan') {
      // For subscription, get the selling plan ID from the radio button
      if (selectedRadio.dataset.sellingPlanId) {
        sellingPlanId = selectedRadio.dataset.sellingPlanId;
        // Save this as the last selected subscription plan ID
        lastSelectedSubscriptionPlanId = sellingPlanId;
        //console.log("Subscription selected, selling plan ID set to:", sellingPlanId);
      } else {
        // Extract real selling plan ID from radio button ID
        const radioId = selectedRadio.id;

        // Try to extract selling plan ID from the radio ID format
        // Expected format: section_id_subscription_SELLING_PLAN_ID_variant_id
        const idParts = radioId.split('_');
        let extractedId = null;

        // Look for numeric selling plan ID in the radio ID
        for (let i = 0; i < idParts.length; i++) {
          const part = idParts[i];
          // Check if this part looks like a selling plan ID (numeric, typically 10+ digits)
          if (/^\d{10,}$/.test(part)) {
            extractedId = part;
            break;
          }
        }

        if (extractedId) {
          sellingPlanId = extractedId;
          //console.log("Extracted selling plan ID from radio ID:", sellingPlanId);
        } else {
          // Final fallback: try to find selling plan ID in any data attribute
          const allAttributes = selectedRadio.attributes;
          for (let attr of allAttributes) {
            if (attr.value && /^\d{10,}$/.test(attr.value)) {
              sellingPlanId = attr.value;
              //console.log("Found selling plan ID in attribute:", attr.name, sellingPlanId);
              break;
            }
          }

          if (!sellingPlanId) {
            //console.log("No selling plan ID found, subscription might not work correctly");
            sellingPlanId = ''; // Leave empty if we can't find a real ID
          }
        }
      }
    }

    // Update the hidden input field with class 'selected-selling-plan-id'
    const sellingPlanInputs = document.querySelectorAll('.selected-selling-plan-id');
    sellingPlanInputs.forEach(input => {
      if (input.closest('[data-e1-pdp-buybox]')) {
        return;
      }

      input.value = sellingPlanId;
    });

    // Update all add-to-cart forms except the SHOP-35 buybox form
    const cartForms = document.querySelectorAll('form[action*="/cart/add"]');
    cartForms.forEach(form => {
      if (form.closest('[data-e1-pdp-buybox]')) {
        return;
      }

      // Find or create the selling_plan input in the form
      let formSellingPlanInput = form.querySelector('input[name="selling_plan"]');
      if (!formSellingPlanInput) {
        formSellingPlanInput = document.createElement('input');
        formSellingPlanInput.type = 'hidden';
        formSellingPlanInput.name = 'selling_plan';
        form.appendChild(formSellingPlanInput);
      }

      // Set the value to the determined selling plan ID
      formSellingPlanInput.value = sellingPlanId;
      //console.log("Updated selling plan in form:", form.id || 'unnamed form', "to:", sellingPlanId);
    });

    // Debug output to verify all forms have been updated
    const allSellingPlanInputs = document.querySelectorAll('input[name="selling_plan"]');
    //console.log("Total selling_plan inputs updated:", allSellingPlanInputs.length);
  }

  // Function to restore the last selected subscription plan
  function restoreLastSelectedSubscriptionPlan() {
    if (!lastSelectedSubscriptionPlanId) return;

    //console.log("Attempting to restore subscription plan ID:", lastSelectedSubscriptionPlanId);

    // Find the option with the matching selling plan ID
    const selectedOption = document.querySelector(`.subscription-plan-option[data-selling-plan-id="${lastSelectedSubscriptionPlanId}"]`);
    if (!selectedOption) {
      //console.log("Could not find option with selling plan ID:", lastSelectedSubscriptionPlanId);
      return;
    }

    //console.log("Found option for plan ID:", lastSelectedSubscriptionPlanId, selectedOption);

    // Get the dropdown parent
    const dropdown = selectedOption.closest('.subscription-plan-dropdown');
    if (!dropdown) return;

    // Update the selected plan text
    const selectedTextElement = dropdown.querySelector('.subscription-plan-selected');
    if (selectedTextElement) {
      selectedTextElement.textContent = selectedOption.dataset.sellingPlanName;
      //console.log("Updated dropdown text to:", selectedOption.dataset.sellingPlanName);
    }

    // Get the radio button and check it
    const radio = selectedOption.querySelector('input[type="radio"]');
    if (radio) {
      radio.checked = true;
      //console.log("Set radio button checked for plan:", lastSelectedSubscriptionPlanId);

      // Trigger the change event on the radio button
      const event = new Event('change', { bubbles: true });
      radio.dispatchEvent(event);
    }

    // Update the hidden selling plan input
    const sellingPlanInputs = document.querySelectorAll('.selected-selling-plan-id');
    sellingPlanInputs.forEach(input => {
      if (input.closest('[data-e1-pdp-buybox]')) {
        return;
      }

      input.value = lastSelectedSubscriptionPlanId;
    });

    // Update all add-to-cart forms except the SHOP-35 buybox form
    const cartForms = document.querySelectorAll('form[action*="/cart/add"]');
    cartForms.forEach(form => {
      if (form.closest('[data-e1-pdp-buybox]')) {
        return;
      }

      // Find or create the selling_plan input in the form
      let formSellingPlanInput = form.querySelector('input[name="selling_plan"]');
      if (!formSellingPlanInput) {
        formSellingPlanInput = document.createElement('input');
        formSellingPlanInput.type = 'hidden';
        formSellingPlanInput.name = 'selling_plan';
        form.appendChild(formSellingPlanInput);
      }

      // Set the value to the determined selling plan ID
      formSellingPlanInput.value = lastSelectedSubscriptionPlanId;
      //console.log("Updated selling plan in form:", form.id || 'unnamed form', "to:", lastSelectedSubscriptionPlanId);
    });

    // Update the price display in the subscription box if needed
    const variantPrice = selectedOption.dataset.variantPrice;
    const variantCompareAtPrice = selectedOption.dataset.variantCompareAtPrice;

    if (variantPrice) {
      const subscriptionItem = dropdown.closest('.subscription-widget__item');
      if (subscriptionItem) {
        const priceElement = subscriptionItem.querySelector('.subscription-widget__item-price');
        if (priceElement) {
          // Find the price span (usually the last span in the container)
          const priceSpan = priceElement.querySelector('span:last-child');
          if (priceSpan) {
            priceSpan.textContent = variantPrice;
            //console.log("Updated price display to:", variantPrice);
          }
        }

        // Update discount badge if it exists
        updateDiscountBadge(variantPrice, variantCompareAtPrice);
      }
    }
  }

  // Function to update the dropdown visual state based on the selected selling plan ID
  function updateDropdownVisualState(sellingPlanId) {
    if (!sellingPlanId) return;

    //console.log("Updating dropdown visual state for selling plan ID:", sellingPlanId);

    // Find the option with the matching selling plan ID
    const selectedOption = document.querySelector(`.subscription-plan-option[data-selling-plan-id="${sellingPlanId}"]`);
    if (!selectedOption) {
      //console.log("Could not find option with selling plan ID:", sellingPlanId);
      return;
    }

    // Get the dropdown parent
    const dropdown = selectedOption.closest('.subscription-plan-dropdown');
    if (!dropdown) return;

    // Update the selected plan text
    const selectedTextElement = dropdown.querySelector('.subscription-plan-selected');
    if (selectedTextElement) {
      selectedTextElement.textContent = selectedOption.dataset.sellingPlanName;
      //console.log("Updated dropdown text to:", selectedOption.dataset.sellingPlanName);
    }

    // Get the radio button and check it
    const radio = selectedOption.querySelector('input[type="radio"]');
    if (radio) {
      radio.checked = true;
      //console.log("Set radio button checked for plan:", sellingPlanId);
    }

    // Update the price display in the subscription box if needed
    const variantPrice = selectedOption.dataset.variantPrice;
    const variantCompareAtPrice = selectedOption.dataset.variantCompareAtPrice;

    if (variantPrice) {
      const subscriptionItem = dropdown.closest('.subscription-widget__item');
      if (subscriptionItem) {
        const priceElement = subscriptionItem.querySelector('.subscription-widget__item-price');
        if (priceElement) {
          // Find the price span (usually the last span in the container)
          const priceSpan = priceElement.querySelector('span:last-child');
          if (priceSpan) {
            priceSpan.textContent = variantPrice;
            //console.log("Updated price display to:", variantPrice);
          }
        }

        // Update discount badge if it exists
        updateDiscountBadge(variantPrice, variantCompareAtPrice);
      }
    }
  }

  // Setup dropdown functionality
  function setupDropdowns() {
    // Get all subscription plan dropdowns
    const dropdowns = document.querySelectorAll('.subscription-plan-dropdown');

    // Add event listeners to each dropdown
    dropdowns.forEach(function (dropdown) {
      // Toggle dropdown on click
      dropdown.addEventListener('click', function (e) {
        const options = dropdown.querySelector('.subscription-plan-options');
        options.classList.toggle('active');

        // Rotate the arrow
        const arrow = dropdown.querySelector('.size-6.relative');
        if (options.classList.contains('active')) {
          arrow.style.transform = 'rotate(0deg)';
        } else {
          arrow.style.transform = 'rotate(-90deg)';
        }
      });

      // Close dropdown when clicking outside
      document.addEventListener('click', function (e) {
        if (!dropdown.contains(e.target)) {
          const options = dropdown.querySelector('.subscription-plan-options');
          options.classList.remove('active');

          // Reset arrow rotation
          const arrow = dropdown.querySelector('.size-6.relative');
          arrow.style.transform = 'rotate(-90deg)';
        }
      });
    });

    // Get all subscription plan options
    const options = document.querySelectorAll('.subscription-plan-option');

    // Add event listeners to each option
    options.forEach(function (option) {
      option.addEventListener('click', function (e) {
        // Get the selected plan data
        const selectedPlan = option.dataset.sellingPlanName;
        const selectedPlanId = option.dataset.sellingPlanId;
        const variantPrice = option.dataset.variantPrice;
        const variantCompareAtPrice = option.dataset.variantCompareAtPrice;

        //console.log("Option clicked with plan ID:", selectedPlanId);

        // Store this as the last selected subscription plan ID
        lastSelectedSubscriptionPlanId = selectedPlanId;

        // Get the dropdown parent
        const dropdown = option.closest('.subscription-plan-dropdown');

        // Update the selected plan text
        const selectedTextElement = dropdown.querySelector('.subscription-plan-selected');
        selectedTextElement.textContent = selectedPlan;

        // Get the radio button and check it
        const radio = option.querySelector('input[type="radio"]');
        radio.checked = true;

        // Update the hidden selling plan input
        const sellingPlanInput = document.querySelector('.selected-selling-plan-id');
        if (sellingPlanInput) {
          sellingPlanInput.value = selectedPlanId;
          //console.log("Updated selling plan ID to:", selectedPlanId);
        }

        // Update the price display in the subscription box
        const subscriptionItem = radio.closest('.subscription-widget__item');
        if (subscriptionItem) {
          const priceElement = subscriptionItem.querySelector('.subscription-widget__item-price');
          if (priceElement) {
            // Find the price span (usually the last span in the container)
            const priceSpan = priceElement.querySelector('span:last-child');
            if (priceSpan) {
              priceSpan.textContent = variantPrice;
              //console.log("Updated price display to:", variantPrice);
            }
          }

          // Update discount badge if it exists
          updateDiscountBadge(variantPrice, variantCompareAtPrice);
        }

        // Trigger the change event on the radio button
        const event = new Event('change', { bubbles: true });
        radio.dispatchEvent(event);

        // Hide the dropdown
        option.closest('.subscription-plan-dropdown').querySelector('.subscription-plan-options').classList.remove('active');

        // Reset arrow rotation
        const arrow = dropdown.querySelector('.size-6.relative');
        arrow.style.transform = 'rotate(-90deg)';

        //console.log("Selected plan:", selectedPlan, "with ID:", selectedPlanId, "Price:", variantPrice);
      });
    });

    // Helper function to update discount badge and unit price
    function updateDiscountBadge(price, comparePrice) {
      if (!price || !comparePrice) return;

      // Calculate discount percentage
      const priceValue = parseFloat(price.replace(/[^0-9.,]/g, '').replace(',', '.'));
      const compareValue = parseFloat(comparePrice.replace(/[^0-9.,]/g, '').replace(',', '.'));
      let discountPercentage = 0;

      if (compareValue > 0 && priceValue > 0) {
        discountPercentage = Math.round((compareValue - priceValue) / compareValue * 100);
        if (discountPercentage < 20) discountPercentage = 20;
      } else {
        discountPercentage = 20; // Default discount
      }

      // Update the discount badge
      const discountBadge = document.querySelector('.subscription-widget__item.selected .text-white');
      if (discountBadge) {
        discountBadge.textContent = "Spare " + discountPercentage + "%";
      }

      // Update the price per portion if it exists
      const unitPriceText = document.querySelector('.subscription-widget__item.selected .opacity-40.text-black');
      if (unitPriceText && priceValue) {
        // Calculate price per portion (assuming 30 portions per package)
        const pricePerPortion = (priceValue / 30).toFixed(2);
        unitPriceText.textContent = "(" + pricePerPortion + "€ / Portion)";
      }
    }
  }

  // Setup one-time quantity tiles functionality
  function setupOnetimeQuantityTiles() {
    // Get all one-time quantity tiles
    const tiles = document.querySelectorAll('.onetime-quantity-tile');

    // Add event listeners to each tile
    tiles.forEach(function (tile) {
      tile.addEventListener('click', function (e) {
        e.stopPropagation();

        // Get the selected quantity data
        const selectedQuantity = tile.dataset.quantity;
        const selectedLabel = tile.dataset.label;
        const selectedPrice = tile.dataset.price;
        const selectedPriceRaw = tile.dataset.priceRaw;

        // Get the tiles container
        const tilesContainer = tile.closest('.onetime-quantity-tiles');
        if (!tilesContainer) return;

        // Remove selected class from all tiles in this container
        const allTiles = tilesContainer.querySelectorAll('.onetime-quantity-tile');
        allTiles.forEach(function (t) {
          t.classList.remove('selected');
          t.classList.remove('border-e1-navy', 'bg-gray-50');
          t.classList.add('border-gray-200');
        });

        // Add selected class to clicked tile
        tile.classList.add('selected');
        tile.classList.remove('border-gray-200');
        tile.classList.add('border-e1-navy', 'bg-gray-50');

        // Find the associated radio button and update its quantity data
        const onetimeItem = tilesContainer.closest('.subscription-widget__item-onetime');
        if (onetimeItem) {
          const radio = onetimeItem.querySelector('input[data-radio-type="one_time_purchase"]');
          if (radio) {
            radio.dataset.quantity = selectedQuantity;
            radio.dataset.variantPrice = selectedPrice;
            radio.dataset.variantPriceRaw = selectedPriceRaw;

            // Update the price display in the one-time box
            const priceElement = onetimeItem.querySelector('.price-final-single');
            if (priceElement) {
              priceElement.textContent = selectedPrice;
            }

            // Deselect all commitment tiles when quantity tile is selected
            deselectAllCommitmentTiles();

            // Automatically select the one-time purchase radio button
            if (!radio.checked) {
              radio.checked = true;
              // Trigger the selection update to handle UI changes and form updates
              updateSelection(radio);
            } else {
              // If already selected, just update the quantity in forms
              updateQuantityInForms(selectedQuantity);
            }
          }
        }
      });
    });
  }

  // Function to deselect all one-time quantity tiles
  function deselectAllOnetimeTiles() {
    // Get all one-time quantity tiles
    const allTiles = document.querySelectorAll('.onetime-quantity-tile');

    // Remove selected styling from ALL tiles (including the first one)
    allTiles.forEach(function (tile) {
      tile.classList.remove('selected');
      tile.classList.remove('border-e1-navy', 'bg-gray-50');
      tile.classList.add('border-gray-200');
    });

    // Reset the one-time radio button data to default (1 month) but don't visually select the tile
    const firstTile = document.querySelector('.onetime-quantity-tile[data-quantity="1"]');
    if (firstTile) {
      const onetimeItem = firstTile.closest('.subscription-widget__item-onetime');
      if (onetimeItem) {
        const radio = onetimeItem.querySelector('input[data-radio-type="one_time_purchase"]');
        if (radio) {
          radio.dataset.quantity = '1';
          radio.dataset.variantPrice = firstTile.dataset.price;
          radio.dataset.variantPriceRaw = firstTile.dataset.priceRaw;

          // Reset the price display to single month price
          const priceElement = onetimeItem.querySelector('.price-final-single');
          if (priceElement) {
            priceElement.textContent = firstTile.dataset.price;
          }
        }
      }
    }
  }

  // Function to ensure at least one one-time tile is selected
  function ensureOnetimeTileSelected() {
    // Check if any tile is currently selected
    const selectedTile = document.querySelector('.onetime-quantity-tile.selected');

    // If no tile is selected, select the first one (1 month)
    if (!selectedTile) {
      const firstTile = document.querySelector('.onetime-quantity-tile[data-quantity="1"]');
      if (firstTile) {
        firstTile.classList.add('selected');
        firstTile.classList.remove('border-gray-200');
        firstTile.classList.add('border-e1-navy', 'bg-gray-50');

        // Update the radio button data to match the selected tile
        const onetimeItem = firstTile.closest('.subscription-widget__item-onetime');
        if (onetimeItem) {
          const radio = onetimeItem.querySelector('input[data-radio-type="one_time_purchase"]');
          if (radio) {
            radio.dataset.quantity = firstTile.dataset.quantity;
            radio.dataset.variantPrice = firstTile.dataset.price;
            radio.dataset.variantPriceRaw = firstTile.dataset.priceRaw;

            // Update the price display
            const priceElement = onetimeItem.querySelector('.price-final-single');
            if (priceElement) {
              priceElement.textContent = firstTile.dataset.price;
            }
          }
        }
      }
    }
  }

  // Function to deselect all commitment tiles
  function deselectAllCommitmentTiles() {
    // Get all commitment tiles
    const allTiles = document.querySelectorAll('.commitment-tile');

    // Remove selected styling from ALL tiles
    allTiles.forEach(function (tile) {
      tile.classList.remove('selected');
      tile.classList.remove('border-e1-navy', 'bg-gray-50');
      tile.classList.add('border-gray-200');
    });

    // Reset subscription radio button commitment data
    const subscriptionRadios = document.querySelectorAll('input[data-radio-type="subscription"]:not([data-e1-pdp-option])');
    subscriptionRadios.forEach(function (radio) {
      // Clear commitment-related data attributes
      delete radio.dataset.minCycle;
      delete radio.dataset.commitmentLabel;
      delete radio.dataset.commitmentDiscount;

      // Find the subscription item and reset prices to original
      const subscriptionItem = radio.closest('.subscription-widget__item');
      if (subscriptionItem) {
        // Reset discount badge to original value from HTML
        const discountBadge = subscriptionItem.querySelector('.text-white');
        if (discountBadge && discountBadge.dataset.originalText) {
          discountBadge.textContent = discountBadge.dataset.originalText;
        }

        // Reset prices to original subscription prices (without commitment discount)
        const priceElement = subscriptionItem.querySelector('.price-final-abo');
        if (priceElement && priceElement.dataset.originalCommitmentPrice) {
          const originalPrice = parseFloat(priceElement.dataset.originalCommitmentPrice);
          const formattedPrice = formatPrice(originalPrice);
          priceElement.textContent = formattedPrice;

          // Reset unit price
          const unitPriceElement = subscriptionItem.querySelector('.unit-price');
          if (unitPriceElement) {
            const pricePerPortion = originalPrice / 30;
            const roundedPricePerPortion = Math.round(pricePerPortion * 100) / 100;
            const formattedUnitPrice = `(${roundedPricePerPortion.toFixed(2).replace('.', ',')}€ / Portion)`;
            unitPriceElement.textContent = formattedUnitPrice;
          }
        }
      }
    });

    console.log('All commitment tiles deselected and prices reset');
  }

  // Function to show one-time quantity tiles with animation
  function showOnetimeQuantityTiles() {
    const quantityTilesContainer = document.querySelector('.onetime-quantity-tiles');
    if (quantityTilesContainer) {
      quantityTilesContainer.style.display = 'block';

      // Trigger slide animation
      setTimeout(() => {
        quantityTilesContainer.classList.add('slide-in');
      }, 50);

      console.log('One-time quantity tiles shown with animation');
    }
  }

  // Function to hide one-time quantity tiles with animation
  function hideOnetimeQuantityTiles() {
    const quantityTilesContainer = document.querySelector('.onetime-quantity-tiles');
    if (quantityTilesContainer) {
      // Remove slide-in class for smooth hide
      quantityTilesContainer.classList.remove('slide-in');

      // Hide after animation completes
      setTimeout(() => {
        quantityTilesContainer.style.display = 'none';
      }, 200);

      console.log('One-time quantity tiles hidden with animation');
    }
  }

  // Function to initialize quantity tiles visibility based on current selection
  function initializeQuantityTilesVisibility() {
    const checkedRadio = document.querySelector('input[type="radio"]:checked');
    if (checkedRadio && checkedRadio.dataset.radioType === 'one_time_purchase') {
      showOnetimeQuantityTiles();
    } else {
      hideOnetimeQuantityTiles();
    }

    // Initialize border colors for the selected option
    if (checkedRadio) {
      updateBorderColors(checkedRadio);
    }
  }

  // Function to show additional information in selected box
  function showAdditionalInfoInBox(selectedRadio) {
    // Hide all additional info sections first
    const allAdditionalInfos = document.querySelectorAll('.additional-info');
    allAdditionalInfos.forEach(info => {
      info.style.display = 'none';
    });

    // Show additional info in the selected box
    const selectedBox = selectedRadio.closest('.subscription-widget__item');
    if (selectedBox) {
      const additionalInfo = selectedBox.querySelector('.additional-info');
      if (additionalInfo) {
        additionalInfo.style.display = 'block';
        console.log('Additional info shown in selected box');
      }
    }
  }

  // Function to hide all additional information sections
  function hideAllAdditionalInfo() {
    const allAdditionalInfos = document.querySelectorAll('.additional-info');
    allAdditionalInfos.forEach(info => {
      info.style.display = 'none';
    });
    console.log('All additional info sections hidden');
  }

  // Function to update border colors and animations for selected option
  function updateBorderColors(selectedRadio) {
    // Reset all items
    const allItems = document.querySelectorAll('.subscription-widget__item, .subscription-widget__item-onetime');
    allItems.forEach(item => {
      item.classList.remove('border-e1-navy', 'selected');
      item.classList.add('border-gray-200');

      // Hide all radio-selected SVGs with animation and show unselected SVGs
      const radioSelected = item.querySelector('.radio-selected');
      const radioUnselected = item.querySelector('.radio-unselected');
      if (radioSelected) {
        // Simple hide without complex animation to avoid conflicts
        radioSelected.classList.remove('show');
        radioSelected.classList.add('hidden');
        radioSelected.style.opacity = '0';
        radioSelected.style.transform = '';
        radioSelected.style.transition = '';
      }
      if (radioUnselected) {
        radioUnselected.classList.remove('hidden');
        radioUnselected.classList.add('show');
        radioUnselected.style.opacity = '1';
      }
    });

    // Set selected item with animations
    const selectedItem = selectedRadio.closest('.subscription-widget__item, .subscription-widget__item-onetime');
    if (selectedItem) {
      selectedItem.classList.remove('border-gray-200');
      selectedItem.classList.add('border-e1-navy', 'selected');

      // Show selected radio SVG with cool animation and hide unselected SVG
      const radioSelected = selectedItem.querySelector('.radio-selected');
      const radioUnselected = selectedItem.querySelector('.radio-unselected');
      if (radioSelected) {
        console.log('Checkmark should now be visible for:', radioSelected);

        // First make it visible
        radioSelected.classList.remove('hidden');
        radioSelected.classList.add('show');
        radioSelected.style.opacity = '1';
        radioSelected.style.display = 'block';

        // Add light bounce effect
        radioSelected.style.transform = 'scale(0.85)';
        radioSelected.style.transition = 'transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1)';

        // Light bounce effect
        setTimeout(() => {
          radioSelected.style.transform = 'scale(1)';
        }, 10);
      }
      if (radioUnselected) {
        radioUnselected.classList.remove('show');
        radioUnselected.classList.add('hidden');
        radioUnselected.style.opacity = '0';
      }

      console.log('Border color and animations updated for selected option');
    }
  }

  // Function to initialize One-Time Box animation
  function initializeOnetimeBoxAnimation() {
    const onetimeBox = document.querySelector('.subscription-widget__item-onetime');
    if (onetimeBox) {
      // Add slide-in animation on page load
      setTimeout(() => {
        onetimeBox.classList.add('slide-in');
      }, 300);

      console.log('One-Time Box animation initialized');
    }
  }

  // Setup commitment tiles function
  function setupCommitmentTiles() {
    // Get all commitment tiles
    const tiles = document.querySelectorAll('.commitment-tile');

    if (tiles.length === 0) {
      console.log('No commitment tiles found');
      return;
    }

    // Add event listeners to each tile
    tiles.forEach(function (tile) {
      tile.addEventListener('click', function (e) {
        e.stopPropagation();

        // Get the selected commitment data
        const selectedMinCycle = tile.dataset.minCycle;
        const selectedLabel = tile.dataset.label;
        const selectedDiscount = tile.dataset.discount;
        const selectedSellingPlanId = tile.dataset.sellingPlanId;

        // Get the tiles container
        const tilesContainer = tile.closest('.commitment-tiles');
        if (!tilesContainer) return;

        // Remove selected class from all tiles in this container
        const allTiles = tilesContainer.querySelectorAll('.commitment-tile');
        allTiles.forEach(function (t) {
          t.classList.remove('selected');
          t.classList.remove('border-e1-navy', 'bg-gray-50');
          t.classList.add('border-gray-200');
        });

        // Add selected class to clicked tile
        tile.classList.add('selected');
        tile.classList.remove('border-gray-200');
        tile.classList.add('border-e1-navy', 'bg-gray-50');

        // Find the associated subscription radio button and update its data
        const subscriptionItem = tilesContainer.closest('.subscription-widget__item');
        if (subscriptionItem) {
          const radio = subscriptionItem.querySelector('input[data-radio-type="subscription"]');
          if (radio) {
            // Store the commitment data for later use
            radio.dataset.minCycle = selectedMinCycle;
            radio.dataset.commitmentLabel = selectedLabel;
            radio.dataset.commitmentDiscount = selectedDiscount;

            // If a specific selling plan ID is provided, use it
            if (selectedSellingPlanId && selectedSellingPlanId !== '') {
              radio.dataset.sellingPlanId = selectedSellingPlanId;
              lastSelectedSubscriptionPlanId = selectedSellingPlanId;
            }

            // Update the discount badge text
            const discountBadge = subscriptionItem.querySelector('.text-white');
            if (discountBadge) {
              // Store original text if not already stored
              if (!discountBadge.dataset.originalText) {
                discountBadge.dataset.originalText = discountBadge.textContent;
              }

              if (selectedDiscount > 0) {
                discountBadge.textContent = `Spare ${selectedDiscount}%`;
              } else {
                // Use original text instead of hardcoded 'Abo-Preis'
                discountBadge.textContent = discountBadge.dataset.originalText;
              }
            }

            // Update prices based on commitment discount
            updateCommitmentPrices(subscriptionItem, selectedDiscount);

            // Automatically select the subscription radio button if not already selected
            if (!radio.checked) {
              radio.checked = true;
              // Trigger the selection update to handle UI changes and form updates
              updateSelection(radio);
            } else {
              // If already selected, just update the selling plan in forms
              updateSellingPlanInForms(radio);
              // Also update sticky cart prices as the unit price might have changed
              updateStickyCartValues(radio);
            }

            console.log(`Selected commitment: ${selectedLabel} (${selectedMinCycle} months, ${selectedDiscount}% discount)`);
          }
        }
      });
    });

    // Initialize with first tile selected by default (monthly - 1 month)
    const firstTile = document.querySelector('.commitment-tile[data-min-cycle="1"]');
    if (firstTile) {
      // Simulate a click on the first tile to set it as default
      setTimeout(() => {
        firstTile.click();
      }, 100);
    }
  }

  // Function to update prices based on commitment discount
  function updateCommitmentPrices(subscriptionItem, discountPercent) {
    if (!subscriptionItem || discountPercent === undefined || discountPercent === null) return;

    // Get the base subscription price (original price without commitment discount)
    const priceElement = subscriptionItem.querySelector('.price-final-abo');
    if (!priceElement) return;

    // Get or store the original price
    let originalPrice = priceElement.dataset.originalCommitmentPrice;
    if (!originalPrice) {
      // Parse current price to get original value
      const currentPriceText = priceElement.textContent.replace(/[€,\s]/g, '').trim();
      let currentPrice = parseFloat(currentPriceText);

      if (!isNaN(currentPrice)) {
        // Check if price is in cents (> 1000 suggests cents)
        if (currentPrice > 1000) {
          currentPrice = currentPrice / 100; // Convert cents to euros
        }
        // Store as original price
        originalPrice = currentPrice;
        priceElement.dataset.originalCommitmentPrice = originalPrice;
      } else {
        // Fallback to the current 1-month list price (99€)
        originalPrice = 99;
        priceElement.dataset.originalCommitmentPrice = originalPrice;
      }
    } else {
      originalPrice = parseFloat(originalPrice);
    }

    // Calculate discounted price
    const discountedPrice = originalPrice * (1 - discountPercent / 100);

    // Format and update the price display
    const formattedPrice = formatPrice(discountedPrice);
    priceElement.textContent = formattedPrice;

    // Update unit price (price per portion)
    const unitPriceElement = subscriptionItem.querySelector('.unit-price');
    if (unitPriceElement) {
      // Calculate price per portion (30 portions per product)
      const pricePerPortion = discountedPrice / 30;
      const roundedPricePerPortion = Math.round(pricePerPortion * 100) / 100; // Round to 2 decimals

      // Format as (X,XX€ / Portion)
      const formattedUnitPrice = `(${roundedPricePerPortion.toFixed(2).replace('.', ',')}€ / Portion)`;
      unitPriceElement.textContent = formattedUnitPrice;
    }

    console.log(`Updated commitment prices: Original €${originalPrice} → Discounted €${discountedPrice.toFixed(2)} (${discountPercent}% off)`);
  }

  // Function to update quantity in all forms
  function updateQuantityInForms(quantity) {
    // Update all add-to-cart forms with the new quantity
    const cartForms = document.querySelectorAll('form[action*="/cart/add"]');
    cartForms.forEach(form => {
      if (form.closest('[data-e1-pdp-buybox]')) {
        return;
      }

      // Find or create the quantity input in the form
      let quantityInput = form.querySelector('input[name="quantity"]');
      if (!quantityInput) {
        quantityInput = document.createElement('input');
        quantityInput.type = 'hidden';
        quantityInput.name = 'quantity';
        form.appendChild(quantityInput);
      }

      // Set the value to the selected quantity
      quantityInput.value = quantity;
    });
  }
});


// Wait for the document to fully load
document.addEventListener('DOMContentLoaded', function () {
  initDiscountHandler();
});

/**
 * SHOP-25: Prefer the global announcement helper (footer snippet); fall back
 * locally when the subscription widget loads without it.
 * @returns {Promise<string|null>}
 */
async function resolveAppliedDiscountCode() {
  if (window.EvertyDiscountAnnouncement && typeof window.EvertyDiscountAnnouncement.resolveAppliedCode === 'function') {
    return window.EvertyDiscountAnnouncement.resolveAppliedCode();
  }

  const fromWindow = window.appliedDiscountCode && String(window.appliedDiscountCode).trim();
  if (fromWindow) return fromWindow;

  const rawCookie = getDiscountCookie('discount_code');
  if (rawCookie) {
    try {
      return decodeURIComponent(rawCookie).trim();
    } catch {
      return rawCookie.trim();
    }
  }

  try {
    const response = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!response.ok) return null;
    const cart = await response.json();
    const codes = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
    const entry = codes.find((item) => item && item.code);
    return entry ? String(entry.code).trim() : null;
  } catch {
    return null;
  }
}

function getDiscountCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  return null;
}

function formatPartnerDiscountMessage(code) {
  if (window.EvertyDiscountAnnouncement && typeof window.EvertyDiscountAnnouncement.formatFallbackMessage === 'function') {
    return window.EvertyDiscountAnnouncement.formatFallbackMessage(code);
  }
  const template = window.partnerDiscountFallbackTemplate || '{{ code }}: Partner-Rabatt aktiv';
  return String(template).replace(/__CODE__|\{\{\s*code\s*\}\}/g, code);
}

function showActiveDiscountBars() {
  const activeDiscountElements = document.querySelectorAll('.active-discount');
  for (const element of activeDiscountElements) {
    element.classList.remove('hidden');
  }
}

function setDiscountAnnouncementText(message) {
  const discountCodeElements = document.querySelectorAll('.cookie_discount_code');
  for (const element of discountCodeElements) {
    element.textContent = message;
  }
}

/**
 * Show the partner-discount announcement without rewriting plan prices.
 * @param {string} discountCode
 */
function showPartnerDiscountAnnouncement(discountCode) {
  if (window.EvertyDiscountAnnouncement && typeof window.EvertyDiscountAnnouncement.show === 'function') {
    window.EvertyDiscountAnnouncement.show(discountCode);
    return;
  }
  setDiscountAnnouncementText(formatPartnerDiscountMessage(discountCode));
  showActiveDiscountBars();
}

// Discount Handler — metaobject match drives client price UI; announcement
// visibility is handled globally (and reinforced here for PDP timing).
function initDiscountHandler() {
  setTimeout(async () => {
    const appliedCode = await resolveAppliedDiscountCode();
    if (appliedCode) {
      window.appliedDiscountCode = appliedCode;
    }

    if (window.validDiscount && window.validDiscount.value) {
      applyDiscount(window.validDiscount.code, parseFloat(window.validDiscount.value));
      return;
    }

    if (appliedCode) {
      showPartnerDiscountAnnouncement(appliedCode);
      showRegularPrices({ keepAnnouncement: true });
      return;
    }

    showRegularPrices();
  }, 100);
}

function applyDiscount(discountCode, discountPercent) {
  // Metaobject match: CODE + percent is the enriched announcement copy.
  setDiscountAnnouncementText(`${discountCode} ${discountPercent}%`);
  showActiveDiscountBars();

  // Show old price elements (strikethrough)
  const priceOldElements = document.querySelectorAll('.price-old');
  for (const element of priceOldElements) {
    element.classList.remove('hidden');
  }

  // Calculate and update discounted prices
  updateDiscountedPrices(discountPercent);

  // Update unit prices in the purchase block, then re-sync sticky bar so its
  // daily price always matches the selected (discounted) plan.
  updateUnitPrices(discountPercent);
  updateStickyCartValues();
}

function updateDiscountedPrices(discountPercent) {
  // Update subscription prices (Abo)
  const priceFinalAboElements = document.querySelectorAll('.price-final-abo');
  priceFinalAboElements.forEach(element => {
    const originalPrice = getOriginalPrice(element, 99); // 1-month list price
    const discountedPrice = calculateDiscountedPrice(originalPrice, discountPercent);
    const formattedPrice = formatPrice(discountedPrice);
    element.textContent = formattedPrice;
  });

  // Update single purchase prices
  const priceFinalSingleElements = document.querySelectorAll('.price-final-single');
  priceFinalSingleElements.forEach(element => {
    const originalPrice = getOriginalPrice(element, 99); // 1-month list price
    const discountedPrice = calculateDiscountedPrice(originalPrice, discountPercent);
    element.textContent = formatPrice(discountedPrice);
  });

  // Update sticky cart price
  updateStickyCartValues();
}

function getOriginalPrice(element, defaultPrice) {
  // Try to get original price from data attribute or parse from text
  const dataPrice = element.dataset.originalPrice;
  if (dataPrice) {
    return parseFloat(dataPrice);
  }

  // Parse current text to extract price
  const priceText = element.textContent.replace(/[€,]/g, '').trim();
  let price = parseFloat(priceText);

  if (!isNaN(price)) {
    // Check if price is in cents (> 1000 suggests cents)
    if (price > 1000) {
      price = price / 100; // Convert cents to euros
    }
    // Store original price for future reference
    element.dataset.originalPrice = price;
    return price;
  }

  // Fallback to default
  element.dataset.originalPrice = defaultPrice;
  return defaultPrice;
}

function calculateDiscountedPrice(originalPrice, discountPercent) {
  return originalPrice * (1 - discountPercent / 100);
}

function formatPrice(price) {
  // Format price to German format: €XX,XX
  const numPrice = parseFloat(price);
  const formattedPrice = numPrice.toFixed(2);
  const parts = formattedPrice.split('.');
  const result = `€${parts[0]},${parts[1]}`;
  return result;
}

function updateUnitPrices(discountPercent) {
  const unitPriceElements = document.querySelectorAll('.unit-price');
  unitPriceElements.forEach(element => {
    // Sticky bar mirrors the selected plan via updateStickyCartValues().
    // Do not recalculate it here — its closest parent is not a plan item, so a
    // fallback list price would produce the wrong daily rate for the selected Laufzeit.
    if (element.closest('#sticky-add-to-cart, .sticky_add_to_cart')) {
      return;
    }

    // Find the parent plan item to locate the correct price
    const item = element.closest('.subscription-widget__item, .subscription-widget__item-onetime');

    let basePrice = 99; // Fallback: 1-month list price

    if (item) {
      const priceElement = item.querySelector('.price-final-abo, .price-final-single');
      if (priceElement) {
        basePrice = getOriginalPrice(priceElement);
      }
    } else {
      // Skip orphan unit-price nodes that are not tied to a plan option
      return;
    }

    const discountedPrice = calculateDiscountedPrice(basePrice, discountPercent);

    // Calculate price per portion (30 portions per product)
    const pricePerPortion = discountedPrice / 30;
    const roundedPricePerPortion = Math.round(pricePerPortion * 100) / 100; // Round to 2 decimals

    // Format as X,XX€ / Tag
    const formattedUnitPrice = `${roundedPricePerPortion.toFixed(2).replace('.', ',')}€ / Tag`;
    element.textContent = formattedUnitPrice;
  });
}



/**
 * @param {{ keepAnnouncement?: boolean }} [options]
 */
function showRegularPrices(options = {}) {
  if (!options.keepAnnouncement) {
    const activeDiscountElements = document.querySelectorAll('.active-discount');
    for (const element of activeDiscountElements) {
      element.classList.add('hidden');
    }
  }

  // Reset prices to original values
  const allPriceElements = document.querySelectorAll('.price-final-abo, .price-final-single');
  for (const element of allPriceElements) {
    const originalPrice = element.dataset.originalPrice;
    if (originalPrice) {
      const price = parseFloat(originalPrice);
      element.textContent = formatPrice(price);
    }
  }

  // Reset unit prices to original using the dynamic update function with 0 discount
  updateUnitPrices(0);

  // Sync Sticky Cart
  updateStickyCartValues();
}

// Function to update sticky cart values from selected main option
function updateStickyCartValues(selectedElement) {
  let selectedItem = null;

  if (selectedElement) {
    selectedItem = selectedElement.closest('.subscription-widget__item, .subscription-widget__item-onetime');
  } else {
    selectedItem = document.querySelector('.subscription-widget__item.selected, .subscription-widget__item-onetime.selected');
    // Fallback for one-time checked input if class isn't there yet
    if (!selectedItem) {
      const checkedInput = document.querySelector('.subscription-widget__item input:checked, .subscription-widget__item-onetime input:checked');
      if (checkedInput) {
        selectedItem = checkedInput.closest('.subscription-widget__item, .subscription-widget__item-onetime');
      }
    }
  }

  if (!selectedItem) return;

  const container = selectedItem; // selectedItem IS the container
  const stickyContainer = document.querySelector('#sticky-add-to-cart, .sticky_add_to_cart');

  if (container && stickyContainer) {
    // Sync Price
    const selectedPrice = container.querySelector('.price-final-abo, .price-final-single');
    const stickyPrice = stickyContainer.querySelector('.price-final-abo');

    if (selectedPrice && stickyPrice) {
      stickyPrice.textContent = selectedPrice.textContent;
      // Also copy any data attributes if needed for discount calculations
      if (selectedPrice.dataset.originalPrice) {
        stickyPrice.dataset.originalPrice = selectedPrice.dataset.originalPrice;
      }
    }

    // Sync daily/unit price from the selected plan (prefer .daily-price)
    const selectedUnitPrice = container.querySelector('.daily-price.unit-price, .daily-price, .unit-price');
    const stickyUnitPrice = stickyContainer.querySelector('.unit-price');

    if (selectedUnitPrice && stickyUnitPrice) {
      stickyUnitPrice.textContent = selectedUnitPrice.textContent;
    }

    // Sync Label & Discount Badge
    const isOneTime = container.classList.contains('subscription-widget__item-onetime') ||
      container.querySelector('input[data-radio-type="one_time_purchase"]:checked');

    // Select the label container using robust classes
    const labelSpan = stickyContainer.querySelector('.sticky-cart-label');
    const discountSpan = stickyContainer.querySelector('.sticky-cart-discount');

    if (labelSpan) {
      if (isOneTime) {
        labelSpan.textContent = 'Einmalkauf';
        if (discountSpan) discountSpan.style.display = 'none';
      } else {
        const planTitle = container.querySelector('.font-clash');
        labelSpan.textContent = planTitle?.textContent?.trim() || 'Abo & sparen';
        if (discountSpan) {
          discountSpan.style.display = 'inline';
          // Update discount text if needed
          const discountBadge = container.querySelector('.text-white'); // The badge in the widget
          if (discountBadge) {
            // Clean up text if it says "Spare 20%" -> "(-20%)" or just take percentage
            const text = discountBadge.textContent.trim();
            if (text.includes('%')) {
              const percent = text.match(/\d+%/);
              if (percent) discountSpan.textContent = `(-${percent[0]})`;
            }
          }
        }
      }

      // Re-evaluate star visibility now that the label text may have changed
      updateStickyStarsVisibility();
    }

  }
}

// Initialize original badge texts on page load
function initializeOriginalBadgeTexts() {
  const discountBadges = document.querySelectorAll('.text-white');
  discountBadges.forEach(badge => {
    if (!badge.dataset.originalText && badge.textContent.trim()) {
      badge.dataset.originalText = badge.textContent.trim();
    }
  });
}

// Call initialization when DOM is loaded
document.addEventListener('DOMContentLoaded', initializeOriginalBadgeTexts);

// Prefer a fully readable plan title over stars when both cannot fit on one
// line in the sticky title row (e.g. "Abo 12 Monate" next to the star icons).
function updateStickyStarsVisibility() {
  const label = document.querySelector('.sticky-cart-label');
  if (!label) return;

  const starWrapper = label.previousElementSibling;
  if (!starWrapper || !starWrapper.classList.contains('sticky-cart-stars')) return;

  const titleRow = label.closest('.sticky-cart-title-row');
  if (!titleRow) return;

  // Probe with stars visible and the label forced to a single line so we can
  // compare intrinsic widths without ellipsis/wrap side effects.
  starWrapper.style.display = '';
  const prevWhiteSpace = label.style.whiteSpace;
  label.style.whiteSpace = 'nowrap';

  const gap = parseFloat(getComputedStyle(titleRow).columnGap || getComputedStyle(titleRow).gap) || 0;
  const fitsWithStars =
    starWrapper.offsetWidth + gap + label.scrollWidth <= titleRow.clientWidth + 1;

  label.style.whiteSpace = prevWhiteSpace;
  starWrapper.style.display = fitsWithStars ? '' : 'none';
}

// Debounced resize handler, since wrapping depends on viewport width.
let stickyStarsResizeTimer = null;
function debouncedStickyStarsVisibility() {
  if (stickyStarsResizeTimer) clearTimeout(stickyStarsResizeTimer);
  stickyStarsResizeTimer = setTimeout(updateStickyStarsVisibility, 150);
}

// Initial evaluation once the sticky bar has rendered (small delay so layout
// has settled), plus re-evaluation on resize.
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(updateStickyStarsVisibility, 200);
});
window.addEventListener('resize', debouncedStickyStarsVisibility);